import React from "react";

export default function AddChoiceIcon() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18C14.4183 18 18 14.4183 18 10C18 7.87827 17.1571 5.84344 15.6569 4.34315C14.1566 2.84285 12.1217 2 10 2Z"
        fill="#2C5CC5"
      />
      <path
        d="M14 10C14 10.3866 13.6866 10.7 13.3 10.7H10.7V13.3C10.7 13.6866 10.3866 14 10 14C9.6134 14 9.3 13.6866 9.3 13.3V10.7H6.7C6.3134 10.7 6 10.3866 6 10C6 9.6134 6.3134 9.3 6.7 9.3H9.3V6.7C9.3 6.3134 9.6134 6 10 6C10.3866 6 10.7 6.3134 10.7 6.7V9.3H13.3C13.6866 9.3 14 9.6134 14 10V10Z"
        fill="white"
      />
    </svg>
  );
}
